import  { number_format } from "../../../../config/Helpers";
import { max } from "moment";
import echarts from 'echarts/lib/echarts';


export const rateChart = (rate) => {
    const real_rate = rate / 100;
    const option = {
        tooltip : false,
        series: [
            {
                name: '业务指标',
                type: 'gauge',
                data: [{value: rate, name: '完成率'}],
                label: false,
                title : false,
                axisLine : {
                    lineStyle: {
                        color: [[real_rate, '#7ed321'],[1, '#9ccbff'],[1, '#9ccbff']],
                        width : 20
                    }
                },
                detail : {
                    shadowColor : '#fff', 
                    shadowBlur: 5,
                    offsetCenter: [0, '95%'],
                    formatter : '{value}%',
                    color : "#4990e2",
                    fontSize : 22
                },
                axisLabel : {
                  show : false  
                },
                axisTick :{
                    show : false
                },
                splitLine : {
                    show : false
                },
                markArea: {
                    label : false
                },
                markLine :{
                    label : false
                },
                pointer : {
                    width: 2
                },
                itemStyle : {
                    color :  "#4990e2"
                },
            }
        ]
    };
    return option;
}

export const rateByHotel = (data_rate_hotel) => {
    const option = {
        tooltip: {
            formatter : function (params, ticket, callback) {
                return params.name + ": " + params.value + " %";
            }
        },
        title: false,
        grid: {
            left: '25px',
            right: '4%',
            bottom: '35px',
            top: '25px',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            axisLabel :{
                formatter : '{value}%'
            }
        },
        yAxis: {
            type: 'category',
            data: data_rate_hotel.names,
            
        },
        series: [
            { // For shadow
                type: 'bar',
                silent: true,
                itemStyle: {
                    normal: {color: '#9ccbff'}
                },
                barGap:'-100%',
                barCategoryGap:'40%',
                data: data_rate_hotel.percent_total_hotels
            },
            {
                type: 'bar',
                itemStyle: {
                    normal: {color: '#4990e2'}
                },
                data: data_rate_hotel.values
            }
        ]
    };
    return option;
}

export const rateByProduction = (data_production) => {
    var data_names = [];
    var data_values = [];
    data_production.values.forEach(item => {
        var data = { name : "", value : 0};
        data.name = item.name + " " + number_format(item.value) + " R/N";
        data.value = item.value;
        if (data.value != 0){
            data_values.push(data);
            data_names.push(data.name);
        }
    });
    let option = {
        tooltip: {
            show : true,
            formatter: "{b} <br> ({d}%)"
        },
        legend: {
            orient: 'vertical',
            data : data_names,
            formatter: '{name}',
            top : "25px",
            right : "5px",
            type : "scroll",
            width : "400px",
            height : "80%",
        },
        series: {
            type:'pie',
            radius: ['30%', '70%'],
            center: ['30%', '50%'],
            avoidLabelOverlap: true,
            left : 0,
            legendHoverLink : true,
            selectedMode : true,
            label : {
                show : true,
                //formatter : "{c} R/N",
                fontSize : 12,
                //color : "#FFF",
                //backgroundColor : "#4990e2",
                //borderRadius : 5,
                //padding : 3

            },
            itemStyle: {
                emphasis: {
                    shadowBlur: 17,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            },
            data: data_values
        }
    };
    
    return option;
}

export const rateByProductionBar = (data_production) => {
    var data_names = data_production.room_names;
    var data_values = [];
    var data_categories = data_production.names;
    var series = [];
    var count = 0;

    Object.keys(data_production.values).forEach(function(key) {
        var data_serie = [];
        Object.keys(data_production.values[key]).forEach(function(key_in) {
            data_serie.push(data_production.values[key][key_in].value);
        });
        //console.log(data_serie);
        series[count] = {
            name:key,
            type:'bar',
            stack: '1',
            label : {
                show : true,
                fontSize : 12,
                position: 'insideLeft',
                formatter : '{c}%'
            },
            data: data_serie
        };
        count++;
    });

    let option = {
        grid: {
            left: '25px',
            right: '280px',
            bottom: '85px',
            top : '50px',
            containLabel: true
        },
        tooltip: {
            trigger: 'axis',
            axisPointer : {
                type : 'shadow'       
            }
        },
        legend: {
            data : data_names,
            formatter: '{name}',
            orient : "vertical",
            top : "25px",
            right : "15px",
            type : 'scroll',
            bottom : '70px'
        },
        xAxis:  {
            type: 'value',
            axisLabel : {
                formatter : "{value}%"
            }
        },
        yAxis: {
            type: 'category',
            data: data_categories
        },
        series: series
    };
    
    return option;
}

export const rateByTrending = (data_trending_time) => {

    let option = {
        legend: {
            orient : "vertical",
            data: data_trending_time.property_names,
            top : "25px",
            right : "25px",
            type : 'scroll'
        },
        tooltip : {
            trigger: 'axis',
            //formatter: "{a} - {b} : {c}%"
        },
        grid: {
            left: '3%',
            right: '250px',
            bottom: '3%',
            top : "25px",
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: true,
            data: data_trending_time.month_names
        },
        yAxis: {
            type: 'value',
            boundaryGap: true,
            axisLabel : {
                formatter : "{value}%"
            }
        },
        series: data_trending_time.values
    };
    
    return option;
}
export const calendarTrending = (data_year_trending) => {
    var month_begin = data_year_trending["year_value"][0].split("-");
    var month_end = data_year_trending["year_value"][1].split("-");
    var graph_width = 'auto';
    if((month_end[1] - month_begin[1]) < 6){
        graph_width = (month_end[1] - month_begin[1] + 1)*100;
    }
    if((month_end[1] == month_begin[1]) && (month_end[0] == month_begin[0])){
        var new_month =  +month_begin[1] + 1;
        data_year_trending["year_value"][1] = month_begin[0]+"-"+(new_month)+"-"+month_begin[2];
    }
    //console.log( data_year_trending["year_value"][1]);
    let option = {
        tooltip: {
            position: 'top',
            formatter: function (p) {
                var format = echarts.format.formatTime('dd-MM-yyyy', p.data[0]);
                return format + ': ' + p.data[1] + ' R/N';
            }
        },
        visualMap: {
            show : false,
            calculable: true,
            orient: 'horizontal',
            left: 'center',
            top: 'top',
            min : 1,
            max : data_year_trending["max_value"],
        },
        calendar: [
        {
            range: data_year_trending["year_value"],
            left : '25',
            top : 25,
            cellSize : [19,20],
            //width: "auto",
            yearLabel : {
                color : "#4da1ff",
                show: false
            },
            itemStyle: {
                normal: {
                    borderWidth: 1.5,
                    color: '#f6efa6'
                }
            },
            dayLabel : {
                nameMap: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
            },
            monthLabel : {
                formatter: function (param) {
                    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AGU", "SEP", "OCT", "NOV", "DEC"];
                    const index = parseInt(param.MM) - 1;
                    return months[index];
                }
            }
        }],
        
        series : data_year_trending["series"]
    };
    return option
}

export const degreeOccupancyTime  = (data_degree_occupancy_time) => {

    let option = {
        legend: {
            orient : "vertical",
            data: data_degree_occupancy_time.type_names,
            top : "25px",
            right : "25px"
        },
        // tooltip : {
        //     trigger: 'item',
        //     //formatter: "{a} <br/>{b} : {c} R/N"
        //     formatter : function (params, ticket, callback) {
        //         console.log(params);
        //         return params.seriesName + "<br/> " + params.name + " : " + number_format(params.value) + " R/N";
        //     }
        // },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#999'
                }
            },
            formatter : function(params){
                const decimals = 0;
                const occupied =  number_format(params[0].value,decimals);
                const availability = number_format(params[1].value, decimals);
                const oos = number_format(params[2].value, decimals);
                const budget = number_format(params[3].value, decimals);
                return "<div style='text-align : left;'>" + 
                    "<span style='display: inline-block; width : 10px; height : 10px; background : #7ed321; border-radius : 2px;'></span> Occupied: " + occupied + " R/N<br />" + 
                    "<span style='display: inline-block; width : 10px; height : 10px; background : #4da1ff; border-radius : 2px;'></span> Availability: "+ availability + " R/N<br />" + 
                    "<span style='display: inline-block; width : 10px; height : 10px; background : #f8e71c; border-radius : 2px;'></span> OOS Rooms: " + oos + " R/N<br />" +
                    "<span style='display: inline-block; width : 10px; height : 10px; background : #fab933; border-radius : 2px;'></span> Budget: " + budget + " R/N<br />" +
                "</div>";
            }
        },
        grid: {
            left: '3%',
            right: '150px',
            bottom: '3%',
            top : "25px",
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: true,
            data: data_degree_occupancy_time.month_names,
        },
        yAxis: {
            type: 'value',
            boundaryGap: true,
            axisLabel : {
                formatter : function(value, index){
                    return number_format(value) + " R/N"
                }
            }
        },
        series: data_degree_occupancy_time.values
    };
    return option;
}



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/occupancy/widgets/Charts.js